import Userback, { UserbackWidget } from "@userback/widget";
import { createContext, ReactNode, useContext, useEffect, useState } from "react";

const UserbackContext = createContext<UserbackWidget | null>(null);

interface UserbackProviderProps {
	children: ReactNode;
	email: string;
	username: string;
	tenantId: string;
	name: string;
	roles: string;
	groups: string;
	localAccountId: string;
}

const userbackToken = "39082|77499|8eVWrmAYGwYYzfcpi79dmtY1M";

export const UserbackProvider = ({
	children,
	email,
	username,
	tenantId,
	name,
	roles,
	groups,
	localAccountId,
}: UserbackProviderProps) => {
	const [userback, setUserback] = useState<UserbackWidget | null>(null);

	useEffect(() => {
		const init = async () => {
			const instance = await Userback(userbackToken, {
				email,
				user_data: {
					id: `${username}@${tenantId}`,
					info: {
						name,
						email,
						roles,
						groups,
						objectId: localAccountId,
						tenantId,
					},
				},
			});
			setUserback(instance);
		};

		init();
	}, [email, localAccountId, tenantId, username, name, roles, groups]);

	return <UserbackContext.Provider value={userback}>{children}</UserbackContext.Provider>;
};

export const useUserback = () => useContext(UserbackContext);
